import React from "react"
import styled, { css, keyframes } from "styled-components"
import MenuItems from "./MenuItems"
import { Link } from "gatsby"

import Typography from "@material-ui/core/Typography"

import * as theme from "../../theme"

const MobileMenu = props => {
  return (
    <Menu {...props} aria-hidden={!props.menuState}>
      <MenuItems slug="main-menu">
        {items => {
          return items.map(
            ({ pathname, active, activeParent, title }, index) => (
              <Item
                menu_open={props.menuState ? 1 : undefined}
                index={index}
                key={pathname}
                to={pathname}
                className={
                  active || activeParent ? "active menu-item" : "menu-item"
                }
              >
                <Title className="item-title">{title}</Title>
              </Item>
            )
          )
        }}
      </MenuItems>
    </Menu>
  )
}

export default MobileMenu

const fadeUp = keyframes`
  from {
    transform: translateY(140%);
     opacity: 0;
  }

  to {
   transform: translateY(0);
    opacity: 1;
  }
`

const menuClose = css`
  opacity: 0;
  pointer-events: none;
`
const menuOpen = css`
  opacity: 1;
  pointer-events: all;
`

const Menu = styled.div`
  ${props => (!!props.menuState ? menuOpen : menuClose)}
  position: fixed;
  top: 100px;
  height: 100%;
  width: 100%;
  z-index: 100;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  transition: all 150ms ease-in-out;
  background: ${theme.color.primary};
  padding: 60px 0;
  @media (min-width: 909px) {
    display: none;
  }
`
const Item = styled(Link)`
  ${({ menu_open, index }) =>
    menu_open &&
    css`
      animation: ${fadeUp} 150ms ${parseFloat("0." + index)}s 1 normal forwards;
    `}

  transform: translateY(100%);
  opacity: 0;
  color: white;
  text-decoration: none;
  padding: 8px 16px;
  width: 100%;
  transition: all 150ms ease-in-out;
`
const NavItem = props => {
  return <Typography {...props} variant="h2" component="div" gutterBottom />
}
const Title = styled(NavItem)`
  padding: 5px 0;
  color: white;
  text-transform: uppercase;
  text-align: center;
`
